export const fontFamilies = {
  bold: "'Avenir Black', 'Arial Black', sans-serif",
  light: "'Avenir Light', 'Arial', sans-serif",
  regular: "'Avenir', 'Arial', sans-serif",
};
